// @flow
import * as UAParser from "ua-parser-js";

var parser = new UAParser();

const getPlatform = () => {
  try {
    const os = parser.getOS();
    switch (os.name) {
      case "iOS":
        return "iOS";
      case "Android":
        return "Android";
      default:
        return "Web";
    }
  } catch (error) {
    console.log("Get platform error", error);
    return "No platform";
  }
};
let RECORD_DURATION = 30 * 1000;
let live = true;

// Очень важно, чтобы вначале html странички была строка:
// <script>window.PAGE_LOAD_TIMESTAMP = Date.now();</script>

const pageId = String(Math.random());
const platform = getPlatform();

let timeline = [
  {
    id: pageId,
    info: "Page Load",
    type: 0,
    timestamp: window.PAGE_LOAD_TIMESTAMP,
    platform
  },
  { id: pageId, info: "Page Load", type: 1, timestamp: Date.now(), platform }
];

export function trackOnTimeline(promise, info) {
  let id = String(Math.random());

  if (live) {
    timeline.push({ id, info, type: 0, timestamp: Date.now(), platform });
    return promise.then(
      value => {
        timeline.push({ id, info, type: 1, timestamp: Date.now(), platform });
        return value;
      },
      error => {
        timeline.push({ id, info, type: 1, timestamp: Date.now(), platform });
        throw error;
      }
    );
  } else {
    return promise;
  }
}

const timer = window.setTimeout(() => {
  live = false;

  fetch(`${window.CRASH_LOGGER_API_URL}/wmetrics`, {
    method: "POST",
    body: JSON.stringify(timeline)
  }).catch(error => {
    console.log(error);
    window.clearTimeout(timer);
  });

  timeline = [];
}, RECORD_DURATION);



// WEBPACK FOOTER //
// ./src/components/common/Timing.js